import Utility from "../../classes/utility";

class AwardsCustomRender {
    static customRender(item)
    {
        // let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        // let cDate = function(dateString) {
        //     let tempDate = dateString.split("-");
        //     return months[Number(tempDate[1]) - 1] + " " + tempDate[2] + ", " + tempDate[0];
        // }
        item.id = Utility.randomLetters(12);
        //item.credentialsDisplay = item.credentials.join(", ");
        //item.deadlineEndDisplay = cDate(item.deadlineEnd);
        return item;
    }
}

export default AwardsCustomRender;